/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 1
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FinanceProductInfoContentFromJSON, FinanceProductInfoContentToJSON, } from './FinanceProductInfoContent';
/**
 * Check if a given object implements the FinanceProductInfoSection interface.
 */
export function instanceOfFinanceProductInfoSection(value) {
    if (!('heading' in value) || value['heading'] === undefined)
        return false;
    if (!('content' in value) || value['content'] === undefined)
        return false;
    return true;
}
export function FinanceProductInfoSectionFromJSON(json) {
    return FinanceProductInfoSectionFromJSONTyped(json, false);
}
export function FinanceProductInfoSectionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'heading': json['heading'],
        'content': (json['content'].map(FinanceProductInfoContentFromJSON)),
    };
}
export function FinanceProductInfoSectionToJSON(json) {
    return FinanceProductInfoSectionToJSONTyped(json, false);
}
export function FinanceProductInfoSectionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'heading': value['heading'],
        'content': (value['content'].map(FinanceProductInfoContentToJSON)),
    };
}
